import { generateString, setPageAsFullHeight } from '@local_modules/flokit'
import { fillString } from '@local_modules/generic/string-template.js'

import htmlTemplateIndex from './index.html'

import { applyHtmlRestrictions } from '../../../helpers/restrictions/apply-html-restrictions.js'
import { checkPageRestriction } from '../../../helpers/restrictions/check-page-restriction.js'

import { setElementHtml } from '../../../helpers/generic-js/dom.js'
import { showCheckItems } from './list-items/show-check-items.js'

/**
 *
 * @param {*} organisationAccess
 */
export function showPageCheckVsXero (params) {
  const { containerElementId, browserAppUser, browserAppEntity, accountingOrganisationId } = params

  if (!checkPageRestriction({ browserAppUser, allowNoAccount: true })) return

  // Prepare the html
  let htmlIndex = htmlTemplateIndex

  htmlIndex = applyHtmlRestrictions(htmlIndex, { browserAppUser })
  const elementId = 'i' + generateString()
  htmlIndex = fillString(htmlIndex, {
    elementId,
    accountingOrganisationId,
    entityName: browserAppEntity?.data?.appEntity?.name
  })

  // Inject in the page
  setElementHtml(containerElementId, htmlIndex)

  setPageAsFullHeight(true, { containerSelector: '#app-content' })

  const checkItemsModule = showCheckItems('checkItems', browserAppEntity)
  console.log('checkItemsModule', checkItemsModule)

  document.getElementById('runAllChecks').addEventListener('click', async () => {
    await checkItemsModule.runAllChecks()
  })
}
